export const authError = (response) => {
    const code = response.networkError?.result?.errors[0]?.extensions?.code;
    if (code && ["AUTHENTICATION_ERROR", "ID_TOKEN_EXPIRED"].includes(code)) {
        return true;
    } else {
        return false;
    }
}